/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Oto_H1Inputs */

const en_simple_oto_h1 = /** @type {(inputs: Simple_Oto_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe your idea. Bystep builds it.`)
};

const id_simple_oto_h1 = /** @type {(inputs: Simple_Oto_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ceritakan idemu. Bystep yang membangun.`)
};

/**
* | output |
* | --- |
* | "Describe your idea. Bystep builds it." |
*
* @param {Simple_Oto_H1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_oto_h1 = /** @type {((inputs?: Simple_Oto_H1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Oto_H1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_oto_h1(inputs)
	return en_simple_oto_h1(inputs)
});